import { useEffect, useState } from "react";

import { fetchBusinessProfile } from "../services/lookupService";

/**
 * Who the business serves, and so which genders its branches may take — read
 * fresh from /business/profile rather than from the stored login, because only
 * the admin sets it and may change it at any time. The server decides anyway;
 * this only picks the right control.
 *
 * `allowedGenders` is ["male"], ["female"] or ["male", "female"].
 */
export default function useBusinessGender(enabled = true) {
  const [state, setState] = useState({ servedGender: null, allowedGenders: [], loading: true });

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;

    (async () => {
      try {
        const business = await fetchBusinessProfile();
        if (!cancelled) {
          setState({
            servedGender: business?.served_gender ?? null,
            allowedGenders: business?.allowed_branch_genders ?? [],
            loading: false,
          });
        }
      } catch {
        // Offer the open choice; the API refuses a wrong one and the 422 lands
        // on the field.
        if (!cancelled) setState({ servedGender: null, allowedGenders: ["male", "female"], loading: false });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
